import styled from 'styled-components'

export const NormalGrid = styled.div<{ $cols?: number }>`
  display: grid;
  gap: 10px;
  justify-content: center;
  grid-template-columns: ${(props) => (props.$cols ? `repeat(${props.$cols}, 150px)` : 'repeat(auto-fit, 150px)')};
  grid-auto-rows: 150px;
`
